import PropTypes from 'prop-types';

export const BlogHero = ({title, image, author, date}) => {
    return (
        <div className="relative w-screen">
            {/* Image Container */}
            <div className="relative h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px] w-full overflow-hidden">
                <img 
                    src={image} 
                    alt={title}
                    className="w-full h-full object-cover"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/30" />
            </div>

            {/* Content Container */}
            <div className="absolute inset-0 flex items-end md:items-center">
                <div className="w-full max-w-[680px] mx-auto px-4 md:px-8 lg:px-0 pb-8 md:pb-0">
                    {/* Breadcrumb - Hidden on mobile */}
                    <div className="hidden md:flex items-center gap-2 text-sm text-gray-200 mb-4">
                        <a 
                            href="/" 
                            className="hover:text-white transition-colors"
                        >
                            Home
                        </a>
                        <span>/</span>
                        <span>Blog</span>
                    </div>

                    {/* Title */}
                    <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
                        {title}
                    </h1>

                    {/* Meta Information */}
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 text-gray-200">
                        <span className="text-sm md:text-base">{author}</span>
                        <span className="hidden sm:block">•</span>
                        <span className="text-sm md:text-base">{date}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

BlogHero.propTypes = {
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired
};

export default BlogHero;